<template>
    <div>
    	<Card>
		<Row :gutter="16">
			<Col span="24">
				<Tabs value="name1">
					<TabPane label="关于我们" name="name1">
						<AboutUS ref="aboutUS" />
					</TabPane>
					<TabPane label="联系我们" name="name2">
						<ContactUs ref="contactUs" />
					</TabPane>
				</Tabs>	
			</Col>
		</Row>
		</Card>
	</div>
		
</template>

<script>

import AboutUS from './about-us.vue';
import ContactUs from './contact-us.vue';
import { addOrderPaybackPackageFee, getOrderPaybackPackageFeeList } from "@/api/modules/finance-management/package-fee";
export default {
    name:'AboutContactingUs',
    components:{ AboutUS, ContactUs },
    data(){
        return{};
    },
    mounted(){
    },
    methods:{}
};	
</script>

<style lang="less" scoped>
</style>